/**
 * Como a situação de um colaborador é escrita.
 *
 * Papel: aqui fica `ROTULO_DO_STATUS`, o texto de cada `status` de
 * colaborador na tabela da equipe, na folha de impressão e na planilha.
 *
 * Como usar: quem escreve a situação de uma pessoa lê daqui, e não do valor
 * do enum. Uma segunda tabela de rótulos em outro arquivo faria a tela dizer
 * "Diarista" e a planilha da mesma pessoa dizer outra coisa.
 */
import { type Colaborador } from '@concierge/shared';

/** O texto de cada situação, como a tela, a folha e a planilha o escrevem. */
export const ROTULO_DO_STATUS: Record<Colaborador['status'], string> = {
  ativo: 'Ativo',
  desligado: 'Desligado',
  diarista: 'Diarista',
};
